<script lang="ts">
    import SvgIcon from "../SVGIcon.svelte";

    export let actionButton: { label: string; onClick: () => void } | null =
        null;
    export let closable: boolean = false;
    export let message: string;
    export let variant: "warning" | "default" = "default";

    let collapsed = false;
</script>

{#if !collapsed}
    <div class={`banner_wrapper ${variant}`}>
        {#if message}
            <p class="message">{message}</p>
        {/if}

        {#if actionButton}
            <button class="button" on:click={actionButton.onClick}>
                {actionButton.label}
            </button>
        {/if}
        {#if closable}
            <button class="close_button" on:click={() => (collapsed = true)}>
                <SvgIcon name="close" />
            </button>
        {/if}
    </div>
{/if}

<style>
    .banner_wrapper {
        @apply flex items-center px-4 py-3;
    }

    .message {
        @apply flex-grow py-1.5 leading-normal tracking-tight;
    }

    .button {
        @apply ml-2 flex-shrink-0 cursor-pointer rounded-full border-none bg-black px-4 py-2 text-sm font-semibold text-white outline-none !important;
    }

    .close_button {
        @apply reset ml-2 flex flex-shrink-0 cursor-pointer align-middle !important;
    }

    .default {
        @apply bg-neutral-200;
    }

    .warning {
        @apply bg-yellow-300;
    }
</style>
